import React, { useEffect } from 'react';
import { PersonaType, RodRequest } from '@bechtel/types';
import { get } from 'lodash';
import { useParams } from 'react-router-dom';
import { RodRequestCaddy } from './caddy';
import { RodRequestDetailStyled } from './styled';
import { RodRequestHeader } from './header';
import { useRodRequestsDetailsByIdsQuery } from '~/hooks/use-rod-requests-details-by-ids';
import { Spinner, SpinnerSize, Box } from '@bechtel/gds';
import { ErrorRetry, useAppUser } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { RodRequestItemDetail } from './item';

interface RouteParams {
  id: string;
}

export const RodRequestDetail = () => {
  const { id } = useParams<RouteParams>();
  const rodRequestId = decodeURIComponent(id);
  const { user } = useAppUser();

  const [getRodRequestsDetailsByIds, { loading, error, data, refetch }] = useRodRequestsDetailsByIdsQuery(true);

  useEffect(() => {
    getRodRequestsDetailsByIds({
      variables: {
        ids: [rodRequestId],
      },
    });
  }, [getRodRequestsDetailsByIds, rodRequestId]);

  const rodRequestDetails: RodRequest = get(data, 'rodRequestsByIds[0]');

  return (
    <>
      {!loading && !error && rodRequestDetails?.id && (
        <RodRequestDetailStyled
          data-testid="rod-request-details-container"
          flexDirection={{ sm: user?.crewMember?.persona !== PersonaType.ROD_ROOM_ATTENDANT ? 'column' : 'row' }}
        >
          {user?.crewMember?.persona !== PersonaType.ROD_ROOM_ATTENDANT ? (
            <RodRequestHeader rodRequestItem={rodRequestDetails} />
          ) : (
            <RodRequestItemDetail rodRequestDetail={rodRequestDetails} />
          )}
          <RodRequestCaddy rodRequestDetail={rodRequestDetails} />
        </RodRequestDetailStyled>
      )}
      {loading && (
        <Box
          justifyContent={{ sm: 'center' }}
          alignItems={{ sm: 'center' }}
          p={{ sm: '700' }}
          data-testid="loading-rodrequest-detail"
        >
          <Spinner size={SpinnerSize.LARGE} />
        </Box>
      )}
      {!loading && error && (
        <Box data-testid="rod-request-details-error">
          <ErrorRetry refetch={refetch}>
            <Trans>There was a problem loading Rod Request Details. Please click the button below to try again.</Trans>
          </ErrorRetry>
        </Box>
      )}
    </>
  );
};
